import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface TelephonyNumbersFilters {
  search?: string;
}

export interface TelephonyNumbersState {
  filters: TelephonyNumbersFilters;
  pagination: {
    itemsPerPage: number;
    currentPage: number;
  };
}

const initialState: TelephonyNumbersState = {
  filters: {},
  pagination: {
    itemsPerPage: 10,
    currentPage: 1,
  },
};

export const telephonyNumbersSlice = createSlice({
  name: 'telephonyNumbers',
  initialState,
  reducers: {
    setTelephonyNumbersFilter: (
      state,
      action: PayloadAction<Partial<TelephonyNumbersFilters>>,
    ) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setTelephonyNumbersPagination: (
      state,
      action: PayloadAction<Partial<TelephonyNumbersState['pagination']>>,
    ) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
  },
});

export const {
  setTelephonyNumbersFilter,
  setTelephonyNumbersPagination,
} = telephonyNumbersSlice.actions;

export default telephonyNumbersSlice.reducer;
